"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.XL_MIN = exports.LG_MAX = exports.LG_MIN = exports.MD_MAX = exports.MD_MIN = exports.SM_MAX = exports.SM_MIN = exports.XS_MAX = void 0;
const XS_MAX = 767;
exports.XS_MAX = XS_MAX;
const SM_MIN = 768;
exports.SM_MIN = SM_MIN;
const SM_MAX = 1023;
exports.SM_MAX = SM_MAX;
const MD_MIN = 1024;
exports.MD_MIN = MD_MIN;
const MD_MAX = 1279;
exports.MD_MAX = MD_MAX;
const LG_MIN = 1280;
exports.LG_MIN = LG_MIN;
const LG_MAX = 1535;
exports.LG_MAX = LG_MAX;
const XL_MIN = 1536;
exports.XL_MIN = XL_MIN;
var _default = {
  XS_MAX,
  SM_MIN,
  SM_MAX,
  MD_MIN,
  MD_MAX,
  LG_MIN,
  LG_MAX,
  XL_MIN
};
exports.default = _default;